<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="form_wrap">
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">绘图描述</div>
          </div>
          <div class="btm_area_con">
            <div class="input_wrap" flex-align>
              <input class="input_main" @focus="textarea_focus" @blur="textarea_blur" v-model="inputVal"
                     placeholder="请输入绘画描述"/>
              <i :class="search_tips ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>

            <!-- 输入提示词 -->
            <div class="search_tips" v-show="search_tips">
              <div class="title"><span>免费体验</span> 以下示例</div>
              <div class="tips_list">
                <div class="tips_list_item" v-for="(item, index) in tips_list"
                     @click="choose_tips_item(item)" :key="index">
                  <p class="zh">{{ item.prompt }}</p>
                  <p class="en">{{ item.prompt_en }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="switch">
            <el-switch
                style="zoom: 0.7"
                @change="getPromptData4()"
                active-value="1"
                inactive-value="0"
                active-color="#5865f2"
                inactive-color="#53555f"
                v-model="auto_spell">
            </el-switch>
            <span>一键优化描述词</span>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">模型选择</div>
          </div>
          <div class="model_list">
            <div @click="selectModel(mo)" :class="['model_item', { 'active': mo.name == img_model }]"
                 v-for="mo in model_list">
              <img :src="mo.img_url" alt="">
              <div class="model_title" flex-center>{{ mo.title }}</div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text" flex-align>绘图模式
              <!-- <br/>快速模式：会员专享模式，平均1-2分钟出图（每张消耗4积分） -->
              <el-tooltip placement="top">
                <div slot="content" v-if="!isSeven">普通模式：高峰期预计需要10分钟出图（非会员4积分，普通会员1积分，高级/超级会员免积分）<br/>
                  第快速模式：会员专享模式，平均1-2分钟出图（每张消耗4积分）
                </div>
                <div slot="content" v-if="isSeven">普通模式：高峰期预计需要10分钟出图（非会员4积分，普通会员1积分，高级/超级会员免积分）<br/>极速模式：MJ7.0专属模式（Turbo）生成速度极快（每张消耗8积分）
                </div>
                <i class="el-icon-warning icon"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="fast_wrap" v-if="!isSeven">
            <div @click="is_fast=1" flex-center :class="['fast_item',{'active':is_fast==1}]">快速模式</div>
            <div @click="is_fast=0" flex-center :class="['fast_item',{'active':is_fast==0}]">普通模式</div>
          </div>
          <div class="fast_wrap" v-if="isSeven">
            <div @click="is_fast=2" flex-center :class="['fast_item',{'active':is_fast==2}]">极速模式</div>
            <!-- <div @click="is_fast=1" flex-center :class="['fast_item',{'active':is_fast==1}]">快速模式</div> -->
            <div @click="is_fast=0" flex-center :class="['fast_item',{'active':is_fast==0}]">普通模式</div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title flex jb ac">
            <div class="text"> 上传参考图（可开启风格一致性--sref，角色一致性--cref）</div>
          </div>
          <div class="item_con">
            <div class="upload_area flex">
              <div class="upload_item img_item" v-for="(file, index) in form.upload_list">
                <div class="delete" @click.stop.prevent="deleteUpload(index)">
                  <img src="../img/icon_img48.png" class="icon_delete"/>
                </div>
                <img :src="file.img_src" class="pic"/>
                <div class="truncate">
                  <div class="flex jb ac">
                    <el-popover placement="top" trigger="click" width="210" background-color="#333"
                                v-if="file.is_sref">
                      <div class="popover_box">
                        <p>输入权重值</p>
                        <el-input-number v-model="file.sref" class="num_input" :min="1"
                                         :max="10"></el-input-number>
                      </div>
                      <div slot="reference" class="sty">{{ '::' + file.sref }}</div>
                    </el-popover>
                    <span v-else></span>
                    <p>风格一致性
                      <el-switch v-model="file.is_sref" active-color="#5865f22d"
                                 nactive-color="#ffffff2d">
                      </el-switch>
                    </p>
                  </div>
                  <div class="flex jb  ac">
                    <el-popover placement="top" trigger="hover" width="210" v-if="file.is_cref">
                      <div class="popover_box">
                        <p>输入权重值</p>
                        <el-input-number v-model="file.cref" class="num_input" :min="1"
                                         :max="100"></el-input-number>
                      </div>
                      <div slot="reference" class="sty">{{ '::' + file.cref }}</div>
                    </el-popover>
                    <span v-else></span>
                    <p>角色一致性
                      <el-switch v-model="file.is_cref" @change="crefChange(index)"
                                 active-color="#5865f22d" inactive-color="#ffffff2d">
                      </el-switch>
                    </p>
                  </div>
                </div>
              </div>
              <div class="upload_item" v-show="form.upload_list.length < 4">
                <el-upload class="upload_demo" ref="uploadImg" multiple
                           :action="fileApi + '/api/front/upload/?fdir=mj_iw'" :limit="4" :auto-upload="false"
                           :on-change="handleChange" :on-exceed="handleExceed" :on-success="handleSuccess"
                           :file-list="fileList" accept="image/*" :show-file-list="false">
                  <div class="tips_text flex  fc jb ac" v-if="isLogin">
                    <div class="flex fc jc ac fg1">
                      <i class="el-icon-upload"></i><br>
                      点击上传
                    </div>
                    <div class="truncate">
                      <div class="flex jb ac">
                        <div class="sty">权重</div>
                        <p>风格一致性
                          <el-switch disabled active-color="#5865f22d"
                                     inactive-color="#ffffff2d">
                          </el-switch>
                        </p>
                      </div>
                      <div class="flex jb  ac">
                        <div class="sty">--cw</div>
                        <p>角色一致性
                          <el-switch disabled active-color="#5865f22d"
                                     inactive-color="#ffffff2d">
                          </el-switch>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="tips_text flex  fc jb ac" v-else @click.stop="checkLogin">
                    <div class="flex fc jc ac fg1">
                      <i class="el-icon-upload"></i><br>
                      点击上传
                    </div>
                    <div class="truncate">
                      <div class="flex jb ac">
                        <div class="sty">权重</div>
                        <p>风格一致性
                          <el-switch disabled active-color="#5865f22d"
                                     inactive-color="#ffffff2d">
                          </el-switch>
                        </p>
                      </div>
                      <div class="flex jb  ac">
                        <div class="sty">--cw</div>
                        <p>角色一致性
                          <el-switch disabled active-color="#5865f22d"
                                     inactive-color="#ffffff2d">
                          </el-switch>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="select_tips flex jb ac">
              <div class="text flex ac">
                <span>--iw图片相似度</span>
                <el-tooltip class="item" effect="dark" content="--iw 值越高，上传的图像对最终效果的影响就越大"
                            placement="top">
                  <i class="el-icon-warning icon"></i>
                </el-tooltip>
              </div>
              <div class="split_line">|</div>
              <div class="select_area">
                <el-select v-model="form.iw" class="select_area_el_select" placeholder="请选择">
                  <el-option v-for="item in iw_options" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>

            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title flex jb ac ">
            <div class="text">
              生成尺寸--ar
              <span class="fz12" style="margin-left: 10px;color: #6D6D6D;">选择生成图像的宽度×高度比例</span>
            </div>
          </div>
          <div class="item_con">
            <div class="size_list flex">
              <div class="size_item flex fc jc ac" :class="form.aspect == item.size ? 'active' : ''"
                   @click="choose_aspect(item)" v-for="(item, index) in img_size" :key="index">
                <img :src="require('../img/s' + (index + 1) + '.png')"/>
                <p>{{ item.size }}</p>
                <p>{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title flex jb ac ">
            <div class="text">
              高级参数
            </div>
          </div>
          <div class="item_con">
            <div class="slider_area">
              <div class="slider_item flex ac">
                <p class="tips">--q 质量化
                  <el-tooltip class="item" effect="dark"
                              content="通过更长的时间来处理并产生更高质量、更多细节的图像，值越大出图质量更高。"
                              placement="top">
                    <i class="el-icon-warning icon_tips"></i>
                  </el-tooltip>
                </p>
                <el-slider v-model="form.quality" :max="100" :min="0" class="slider" show-input>
                </el-slider>
              </div>
              <div class="slider_item flex ac">
                <p class="tips">--s 风格化
                  <el-tooltip class="item" effect="dark"
                              content="低风格化值生成的图像与提示非常匹配，但艺术性较差；高风格化值创建的图像非常艺术，但与提示的联系较少"
                              placement="top">
                    <i class="el-icon-warning icon_tips"></i>
                  </el-tooltip>
                </p>
                <el-slider v-model="form.stylize" :max="1000" :min="0" class="slider" show-input>
                </el-slider>
              </div>
              <div class="slider_item flex ac">
                <p class="tips">--c 多样化
                  <el-tooltip class="item" effect="dark" content="这个值越低生成的四张图风格越相似，反之差异越大"
                              placement="top">
                    <i class="el-icon-warning icon_tips"></i>
                  </el-tooltip>
                </p>
                <el-slider v-model="form.chaos" :max="100" :min="0" class="slider" show-input>
                </el-slider>
              </div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title flex jb ac ">
            <div class="text">
              公开作品
            </div>
          </div>
          <div class="item_con">
            <div class="switch_area flex jb ac">
              <p class="tips">开启后您的绘画生成结果将会在公共画廊中展示</p>
              <div class="flex ac">
                <p>{{ form.is_public == 1 ? '开启' : '关闭' }}</p>
                <el-switch v-model="form.is_public" active-color="#5865f2" inactive-color="#5a5c61"
                           active-value="1" inactive-value="0">
                </el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div class="primary_button" @click="sendMsg" v-loading="sending">提交任务</div>
    </div>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      //展示隐藏search_tips
      inputVal: "",
      sending: false,
      search_tips: false,
      //模型列表
      model_list: [{
        img_url: "/static/img/mode/mj5.2.png",
        name: "MJ5.2",
        title: 'MJ5.2(真实细节)',
        desc: '增强真实风格图像细节'
      }, {
        img_url: "/static/img/mode/nj5.0.png",
        name: "NJ5.0",
        title: 'NJ5.0(动漫增强)',
        desc: '增强动漫风格图像细节'
      }, {
        img_url: "/static/img/mode/mj5.1.png",
        name: "MJ5.1",
        title: 'MJ5.1(艺术增强)',
        desc: '专注真实艺术风格图像'
      }, {
        img_url: "/static/img/mode/nj6.0.png",
        name: "NJ6.0",
        title: 'NJ6.0(动漫质感)',
        desc: '官方最新动漫模型同步',
      }, {
        img_url: "/static/img/mode/mj6.0.png",
        name: "MJ6.0",
        title: 'MJ6.0(真实质感)',
        desc: '全新6.0 ALPHA真实风格图像',
      }, {
        img_url: "/static/img/mode/mj6.1.png",
        name: "MJ6.1",
        title: 'MJ6.1(细节文理)',
        desc: 'MJ v6.1震撼来袭',
      }, {
        img_url: "/static/img/mode/mj7.0.png",
        name: "MJ7.0",
        title: 'MJ7.0(细节优化)',
        desc: 'MJ v7.0震撼来袭',
      }],
      is_fast: 1,
      //当前选中模型
      img_model: 'MJ5.2',
      fileList: [],
      iw_options: [
        {
          label: '关闭iw选项',
          value: '0'
        },
        {
          label: '--iw 0.25 相似度30%',
          value: '0.25'
        },
        {
          label: '--iw 0.5 相似度40%',
          value: '0.5'
        },
        {
          label: '--iw 1 相似度50%',
          value: '1'
        },
        {
          label: '--iw 1.25 相似度60%',
          value: '1.25'
        },
        {
          label: '--iw 1.5 相似度70%',
          value: '1.5'
        },
        {
          label: '--iw 1.75 相似度80%',
          value: '1.75'
        },
        {
          label: '--iw 2 相似度90%',
          value: '2'
        },
      ],
      img_size: [
        {
          size: '1:1',
          title: '头像框'
        },
        {
          size: '1:2',
          title: '手机壁纸'
        },
        {
          size: '16:9',
          title: '电脑壁纸'
        },
        {
          size: '9:16',
          title: '宣传海报'
        },
        {
          size: '4:3',
          title: '文章配图'
        },
        {
          size: '3:4',
          title: '媒体配图'
        },
        {
          size: '3:2',
          title: '横版名片'
        },
        {
          size: '2:3',
          title: '小红书图'
        },
      ],
      form: {
        iw: "1.5",
        aspect: "1:1",// 大小比例
        is_public: '0',//是否公开作品
        quality: 99,
        stylize: 100,
        chaos: 0,
        upload_list: [],
      },
      fileApi: FILE_API_SERVER,
      upoadLoading: false,
      uploadError: '',
      okNum: 0,
      totalNum: 0,
      isWxEnv: false,
      sampleTimer: null,
      isSeven: false,
      perIncan: false, // ai提示词是否返回
      auto_spell: '1', // ai提示词是否关闭
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    },
    isInputtype() {
      return this.$store.state.isInputtype;
    },
    isInputVal() {
      return this.$store.state.isInputVal;
    },
  },
  created() {
    if (localStorage.getItem('semText')) {
      this.inputVal = localStorage.getItem('semText')
    }
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.handleDocumentClick);
      let _form = this.getCache("formAdvanceParams") || ""
      if (_form) {
        this.form = JSON.parse(_form)
      }
    }, 100)
  },
  methods: {

    selectModel(mo) {
      this.img_model = mo.name
      if (mo.name == 'MJ7.0') {
        this.is_fast = 2
        this.isSeven = true
      } else {
        this.isSeven = false
        this.is_fast = 1
      }
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
    //关闭search_tips
    close_search_tips() {
      this.search_tips = false
    },
    //输入框获取焦点
    textarea_focus() {
      this.search_tips = true
    },
    //输入框失去焦点
    textarea_blur() {
      setTimeout(() => {
        this.search_tips = false
      }, 100)
    },
    //选择提示词
    choose_tips_item(item) {
      // let _item = { ...item }
      // _item.progress = 0
      // this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")
      // this.sampleUserList = [_item].concat(this.sampleUserList);
      // localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
      if (!this.checkLogin()) return
      let num = localStorage.getItem('mjSampleSysListNum')
      if (num == 1 && this.userInfo.is_vip == 0) {
        console.log('判断是否是vip并且使用过一次了')
        this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
          confirmButtonText: '开通会员',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        }).catch(() => {

        });
        return;
      }
      let _item = {...item}
      _item.progress = 0
      this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")
      this.sampleUserList = [_item].concat(this.sampleUserList);
      localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
      localStorage.setItem('mjSampleSysListNum', '1');
// return;
      this.$emit('select_sample', _item);
    },

    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    choose_aspect(item) {
      this.form.aspect = item.size
    },
    handleDocumentClick(event) {
      // 判断点击的区域是否是 container 元素或其子元素
      if (this.$refs.container && !this.$refs.container.contains(event.target)) {
        // 点击了除 container 以外的区域，执行相应操作
        this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
      }
    },
    crefChange(index) {
      // cref 变化
      if (this.form.upload_list[index].is_cref) {
        let k = 0
        this.form.upload_list.forEach(e => {
          if (k != index) {
            this.form.upload_list[k].is_cref = false
          }
          k += 1
        })
      }
    },
    deleteUpload(index) {
      if (this.upoadLoading) {
        this.$message.error("正在上传，请稍后再操作！")
        return
      }
      let i = -1
      for (let k = 0; k < this.$refs.uploadImg.uploadFiles.length; k++) {
        if (this.form.upload_list[index].lastModified == this.$refs.uploadImg.uploadFiles[k].raw.lastModified) {
          i = k
        }

      }
      this.form.upload_list.splice(index, 1)
      this.fileList.splice(i, 1)
      this.$nextTick(() => {
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      })
    },
    handleChange(file, fileList) {
      if (this.upoadLoading) {
        this.$message.error("正在上传，请稍后再操作！")
        return
      }

      if (this.form.upload_list.length >= 4) {
        return
      }
      if (file.raw.type != "image/jpeg" && file.raw.type != "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        this.$refs.uploadImg.clearFiles()
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        this.$refs.uploadImg.clearFiles()
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
        return
      }

      let img_src = URL.createObjectURL(file.raw);
      let flag = true
      this.form.upload_list.forEach(e => {
        if (e.lastModified == file.raw.lastModified) {
          flag = false
        }
      })
      if (flag) {
        this.form.upload_list.push({
          img_src: img_src,
          img_url: "",
          sref: 0,
          is_sref: 0,
          cref: 0,
          is_cref: 0,
          lastModified: file.raw.lastModified
        })
      } else {
        this.$message.error("请勿上传重复图片")
      }
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      this.submitUpload()
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleSuccess(response, file, fileList) {
      console.log("handleSuccess", response, file)
    },
    async submitUpload() {
      this.okNum = 0
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      if (this.totalNum <= 0) {
        this.$message.error("没有需要上传的文件")
        return
      }
      this.upoadLoading = true
      for (let index = 0; index < this.$refs.uploadImg.uploadFiles.length; index++) {
        this.okNum += 1
        const f = this.$refs.uploadImg.uploadFiles[index];
        await this.uploadFile(f)
      }
      this.$refs.uploadImg.clearFiles()
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      this.upoadLoading = false
      if (this.uploadError.includes("违规")) {
        this.form.upload_list.pop()
        this.$message.error(this.uploadError)
      } else {
        this.$message.success("图片上传完成！")
      }
    },
    async uploadFile(file) {
      let lastModified = file.raw.lastModified
      this.uploadError = ""
      let post_url = await this.$http.get(`${FILE_API_SERVER}/api/front/upload/?file_folder=mj_iw`).then(res => {
        return res.data
      }).catch(e => {
        return ""
      });
      if (!post_url) {
      }
      // 上传图片
      let formData = new FormData();
      formData.append("file", file.raw, file.name);
      let fileResponse = await this.$http.post(post_url, formData, {
        headers: {"Content-Type": "multipart/form-data"},
        responseType: "text"
      }).then(res => {
        return eval(res);
      }).catch(e => {
        return "";
      });
      this.uploadError = fileResponse.data.error
      let file_full_url = fileResponse.data.file_full_url
      this.form.upload_list.forEach(e => {
        if (e.lastModified == lastModified) {
          e.img_url = file_full_url
          e.img_src = file_full_url
        }
      })
    },
    //发送消息
    sendMsg() {
      if (!this.checkLogin()) return
      // if (!this.isLogin) {
      //   if (localStorage.getItem('sampleUserList')) {
      //     this.checkLogin()
      //     return
      //   } else {
      //     this.sampleList[localStorage.getItem('sampleNa')].progress = 0
      //     localStorage.setItem('sampleUserList', JSON.stringify(this.sampleList[localStorage.getItem('sampleNa')]))
      //     this.$emit('semForm')
      //     return
      //   }
      // }

      if (!this.checkLogin()) return
      if(!utils.setOptData(this.userInfo,'btn_mj_create')){
          return
      }
      this.inputVal = this.inputVal.trim();
      if (!this.inputVal) {
        this.$message.warning('请输入文字信息')
        return
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (this.auto_spell > 0) {
        console.log('ai提示词')
        if (!this.perIncan) {
          this.$store.commit('setisInputVal', this.inputVal)
          this.$store.commit('setisInputtype', 'Stable Diffusion')
          this.$store.commit('setisInputValshow', true)
          return;
        }
      }
      let parameters = {
        iw: 0.25,
        aspect: "16:9",// 大小比例
        // tips_text:"",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: []
      }
      parameters = this.form
      // 同步请求
      this.submitQuestion({
        question: this.inputVal,
        parameters: parameters,
        img_model: this.img_model,
        is_fast: this.is_fast,
        iw_url: this.upload_img_url,
        iw: this.img_iw
      });
      // this.$emit('submitForm',{
      //     question: this.inputVal,
      //     parameters: parameters,
      //     img_model: this.img_model,
      //     is_fast: this.is_fast,
      //     iw_url: this.upload_img_url,
      //     iw: this.img_iw
      // });
    },
    submitQuestion(data, parent_msg_code, i) {
      localStorage.removeItem('semText')
      this.sending = true;
      console.log('提交 mj')
      console.log(data)
      // return
      // 提交问题
      data.source = "pc";
      this.perIncan = false
      this.$http.post('/front/aimj/draw/', data).then((res) => {
        if (res.status == 200) {
          this.inputVal = "";
          // this.checkIds.push(res.data.draw.draw_id)
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          // this.fetchMsg();
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
  },
  watch: {
    '$store.state.isInputValshow'(newVal) {
      console.log('isInputValshow 变化:', newVal);
      if (!newVal) {
        if (this.isInputtype.length > 0) {
          this.perIncan = true
          this.inputVal = this.isInputVal
          this.sendMsg()
        }
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 15px;
      height: 100%;
    }

    .options_item {
      margin: 10px 0 10px;

      .switch {
        margin-top: 10px;
        display: flex;
        align-items: center;

        span {
          margin-left: 10px;
        }
      }

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }
      }
    }
  }

  .bottom_area {
    padding-top: 10px;
    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;
    }
  }
}

.btm_area_con {
  position: relative;

  .input_wrap {
    border: 2px solid #5865f2;
    border-radius: 6px;
    background-color: rgba(88, 101, 242, 0.06);

    .input_main {
      flex: 1 1 0%;
      height: 40px;
      font-size: 14px;
      color: #fff;
      border: none;
      background: transparent;
      padding: 1px 15px;
    }

    i {
      margin-right: 10px;
      font-size: 16px;
      color: #7E7E7E;
    }
  }

  .search_tips {
    position: absolute;
    left: 0;
    bottom: 0;
    transform: translateY(100%);
    width: 100%;
    color: #b5bac1;
    background-color: #414347;
    z-index: 10;
    padding: 10px;
    box-shadow: -5px 5px 10px 5px rgba(0, 0, 0, .25);

    .title {
      padding-bottom: 10px;
      padding: 4px;

      span {
        font-weight: bold;
        color: #f90;
      }
    }

    .tips_list {
      height: 300px;
      overflow-y: auto;
      white-space: nowrap;

      .tips_list_item {
        padding: 10px 8px;
        border-radius: 3px;
        cursor: pointer;

        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.model_list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;

  .model_item {
    border-radius: 6px;
    border: 2px solid #1d2027;
    position: relative;
    overflow: hidden;

    &.active {
      border-color: #5865f2;
    }

    img {
      border: none;
      width: 100%;
    }

    .model_title {
      position: absolute;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.73);
      height: 25px;
      font-size: 12px;
      left: 0;
      bottom: 0;
    }
  }
}

.fast_wrap {
  display: flex;
  gap: 10px;

  .fast_item {
    border-radius: 6px;
    height: 40px;
    width: 94px;
    color: #8e9093;
    background-color: #1d2027;
    cursor: pointer;

    &.active {
      color: #fff;
      background-color: #303245;
      border: 2px solid #5865f2;
    }
  }
}

.upload_area {
  flex-wrap: wrap;

  .upload_demo {
    height: 100%;

    /deep/ .el-upload {
      width: 100%;
      height: 100%;
      background: transparent;
      border: 0;
    }

    .tips_text {
      height: 100%;

      .el-icon-upload {
        font-size: 40px;
      }

      .fg1 {
        padding: 0 30px;

        p {
          font-size: 14px;
          color: #fff;
        }

        span {
          color: #5865f2;
        }
      }

      .truncate {
        height: 60px;
        background: #000;
      }
    }
  }
}

.upload_item {
  width: 200px;
  height: 200px;
  background: transparent;
  border: 2px dashed #5e6166;
  background: #2b2d31;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;

  .truncate {
    width: 100%;
    padding: 0 8px;
    font-size: 12px;

    .flex {
      padding: 5px 0;
    }

    .sty {
      line-height: 20px;
      background: #5865f2;
      border-radius: 4px;
      color: #fff;
      padding: 0 5px;
      cursor: pointer;
    }

    P {
      /deep/ .el-switch__core {
        margin-left: 5px;
      }
    }
  }
}

.img_item {
  position: relative;

  .delete {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
    }

    &:hover {
      background: #414246;
    }
  }

  .pic {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .truncate {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.67);
  }
}

.popover_box {
  p {
    font-size: 14px;
    color: #fff;
    text-align: center;
    margin-bottom: 5px;
  }

  .num_input {
    width: 100%;
    line-height: 28px;
    border: 1px solid #5865f2;
    border-radius: 4px;

    /deep/ .el-input-number__increase,
    /deep/ .el-input-number__decrease {
      background: transparent;
      border: none;
      color: #fff;
    }

    /deep/ .el-input__inner {
      height: 28px;
      line-height: 28px;
      border: 0;
      background: transparent;
      color: #fff;
      font-size: 14px;
    }
  }
}

.select_tips {
  width: 434px;
  max-width: 100%;
  margin-top: 10px;
  background: #242830;
  border-radius: 4px;
  padding: 0 10px;
  color: #cbcbcb;

  .text {
    font-size: 14px;
    flex-shrink: 0;

    img {
      width: 16px;
      height: 16px;
      margin-left: 5px;
    }
  }

  .split_line {
    margin-left: 10px;
    margin-right: 10px;
  }

  /deep/ .el-input__inner {
    background: transparent;
    border: 0;
    color: rgba(255, 255, 255, .78) !important;
    padding: 0;
  }
}

.btn_area {
  .btn {
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 14px;
    margin-left: 5px;
    color: #5865f2;
    border: 1px solid #5865f2;
    cursor: pointer;
  }
}

.input_textarea {
  border: 1px solid #393c43;
  border-radius: 8px;
  margin: 10px 0;
  padding: 10px;

  .tags_list {
    width: 412px;
    height: 60px;
  }

  p {
    font-size: 12px;
    color: #fff;
    opacity: 0.69;
    text-align: right;
  }
}

.size_list {
  padding-top: 14px;
  flex-wrap: wrap;

  .size_item {
    border: 2px solid #393c43;
    width: 70px;
    height: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    cursor: pointer;

    img {
      width: 36px;
      height: 40px;
    }

    p {
      font-size: 12px;
      color: #8e9093;
      margin-top: 6px;
    }

    &.active {
      border: 2px solid #5865f2;
    }
  }
}

.slider_area {
  .slider_item {
    margin-top: 10px;
    justify-content: space-between;

    .tips {
      font-size: 14px;
      color: #cbcbcb;
      flex: 2;
      margin-right: 12px;
    }

    .icon_tips {
      margin-left: 4px;
      cursor: pointer;
      color: #4a4c52;
    }

    .slider {
      flex: 7;
      width: 100%;
      height: 24px;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
    }

    /deep/ .el-input-number__increase,
    /deep/ .el-input-number__decrease {
      background: #242830;
      border: none;
      color: #fff;
      width: 24px;
      height: 22px;
      line-height: 24px;
      color: #999;
    }

    /deep/ .el-slider__input {
      width: 80px;
      line-height: 26px;
    }

    /deep/ .el-input__inner {
      height: 26px;
      line-height: 26px;
      border: 0;
      background: #242830;
      color: #d4d4d4;
      font-size: 12px;
      padding-right: 29px;
      padding-left: 29px;
    }

    /deep/ .el-slider__runway {
      margin-right: 30px;
      flex: 1;
      background-color: #4a4d52;
      position: relative;
      cursor: pointer;
    }

    /deep/ .el-slider__button {
      border-color: #5865f2;
    }

    /deep/ .el-slider__bar {
      background: #5865f2;
    }
  }
}

.switch_area {
  margin-top: 10px;
  color: #6d6d6d;
  font-size: 12px;

  .tips {
    overflow: hidden;
    flex: 1 1 0%;
  }
}

.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
  }
}

/deep/ .el-loading-mask {
  background: none;
}
</style>